<template>
  <div class="relative" v-if="item.path || item.items.length > 0">
    <component
      :is="component"
      :href="item.path ?? null"
      @click.prevent="handleClick"
      :tabindex="displayAsButton ? 0 : null"
      class="panel-mobile-menu-row w-full text-menu-item"
      :class="{
        'panel-mobile-menu-row--interactive cursor-pointer dark:hover:bg-gray-800/80':
          displayAsButton,
        'panel-mobile-menu-row--active font-bold text-primary-500 dark:text-primary-400': item.active,
      }"
    >
      <span class="panel-mobile-menu-row__icon">
        <NavIcon :name="item.icon" width="20" height="20" />
      </span>

      <span class="panel-mobile-menu-row__label">
        {{ item.name }}
      </span>

      <span v-if="item.badge" class="panel-mobile-menu-row__badge shrink-0">
        <Badge :extra-classes="item.badge.typeClass">
          {{ item.badge.value }}
        </Badge>
      </span>

      <span
        v-if="item.collapsable"
        class="panel-mobile-menu-row__chevron"
      >
        <CollapseButton :collapsed="collapsed" :to="item.path" />
      </span>
    </component>

    <div
      v-if="item.items.length > 0 && !collapsed"
      class="panel-mobile-menu__submenu"
      data-submenu-open="true"
    >
      <component
        :is="item.component"
        v-for="child in item.items"
        :key="child.name"
        :item="child"
      />
    </div>
  </div>
</template>

<script>
import { Collapsable } from '@/mixins'
import { mapGetters, mapMutations } from 'vuex'
import NavIcon from './NavIcon.vue'

export default {
  components: {
    NavIcon,
  },

  mixins: [Collapsable],

  props: ['item'],

  methods: {
    ...mapMutations(['toggleMainMenu']),

    handleClick() {
      if (this.item.collapsable) {
        this.toggleCollapse()
      }

      if (this.mainMenuShown && this.component !== 'button') {
        this.toggleMainMenu()
      }
    },
  },

  computed: {
    ...mapGetters(['mainMenuShown']),

    component() {
      if (this.item.path) {
        return 'Link'
      }

      if (this.item.items.length > 0 && this.item.collapsable) {
        return 'button'
      }

      return 'h3'
    },

    displayAsButton() {
      return ['Link', 'button'].includes(this.component)
    },

    collapsedByDefault() {
      return this.item?.collapsedByDefault ?? false
    },
  },
}
</script>
